<template>
  <div class="text-wrap">
    <p
      class="text bold"
      v-html="content"></p>
  </div>
</template>

<script>
export default {
  name: 'FullWithText',
  props: {
    content: {
      type: String,
      default: null
    }
  }
}
</script>

<style lang="scss" scoped>
.text-wrap {
  display: flex;
  width: 100%;
}
</style>
